import { useRef, useEffect } from 'react';

export const usePrevious = <T>(value: T): T | undefined => {
    const ref = useRef<T>();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

export const useHasChanged = <T>(value: T): boolean => {
    const previousValue = usePrevious(value);
    return !previousValue ? false : !(previousValue === value);
};
